import { Colors } from '@factorialco/deprecated-design-system'
import {
  AnalyticsPageEmployeeNamesFragment,
  AnalyticsPageLegalEntitiesFragment,
  AnalyticsPageLocationsFragment,
} from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import { countryName } from 'modules/core/lib/countryList'

import type { TeamsTeam } from 'modules/performance_analytics/hooks/useGroupByKeysLookupTransformer'

export const TOP_VALUES_LIMIT = 10

export const GROUP_BY_COLORS: Colors[] = [
  'group1',
  'group2',
  'group3',
  'group4',
  'group5',
  'group6',
  'group7',
  'group8',
  'group9',
  'group10',
  'group11',
]

export type GroupByType =
  | 'gender'
  | 'legal_entity'
  | 'workspace'
  | 'nationality'
  | 'manager'
  | 'team'
  | null

export type MetricType = 'headcount' | 'performance' | 'employee_pulse' | '9_box_grid' | null

export const mapGroupByValueToName = (
  value: string | number,
  groupBy: string | null | undefined,
  legalEntities: AnalyticsPageLegalEntitiesFragment[] | undefined = [],
  teams: Pick<TeamsTeam, 'id' | 'name'>[] | undefined = [],
  locations: AnalyticsPageLocationsFragment[] | undefined = [],
  employeesNames: AnalyticsPageEmployeeNamesFragment[] | undefined = []
) => {
  let finalValue = value
  if (groupBy === 'legal_entity') {
    finalValue = legalEntities.find((entity) => entity.id == value)?.legalName ?? value
  }
  if (groupBy === 'team') {
    finalValue = teams.find((team) => team.id == value)?.name ?? value
  }
  if (groupBy === 'workspace') {
    finalValue = locations.find((location) => location.id == value)?.name ?? value
  }
  if (groupBy === 'manager') {
    finalValue = employeesNames.find((employee) => employee.id == value)?.fullName ?? value
  }
  if (groupBy === 'nationality') {
    const name = countryName(value.toString())
    if (!name) {
      finalValue = value
    } else {
      finalValue = name
    }
  }
  return capitalize(finalValue.toString())
}

export const safeParseGroupBy = (groupByRaw: string): GroupByType | undefined => {
  switch (groupByRaw) {
    case 'legal_entity':
      return 'legal_entity'
    case 'manager':
      return 'manager'
    case 'team':
      return 'team'
    case 'workspace':
      return 'workspace'
    case 'nationality':
      return 'nationality'
    case 'gender':
      return 'gender'
    default:
      return undefined
  }
}
